import LoaderComponent from './loader.component'

const LoaderModule = angular.module('cdbl.loader', [

])
  .component('cdblLoader', LoaderComponent)
  .name

export default LoaderModule
